export const AUDIO_TYPES = Object.freeze(["PreRecordedDisclosures", "PreRecordedDisclosuresSpanish"] as const);
export type AudioType = (typeof AUDIO_TYPES)[number];

export function isAudioType(value: string): value is AudioType {
    return (AUDIO_TYPES as readonly string[]).includes(value);
}
